import { useState } from "react";

import { useSignIn } from "@/hooks/use-auth-client";
import useUpdateEffect from "@/hooks/use-update-effect";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";
import { InputPasswordField } from "@/components/ui/form/fields/input-field/input-password";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useLoadingScreen } from "../../side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";
import { AuthForm } from "../_components/auth-form";
import { authSignInInputZodSchema } from "./_schema/validation-schema";

import type { AuthSignInInputType } from "./_schema/validation-schema";
import type { SafeParseError } from "zod";

export const AuthSignIn = () => {
	const [email, setEmail] = useState("");

	const [password, setPassword] = useState("");

	const [validationErrors, setValidationErrors] = useState<SafeParseError<AuthSignInInputType> | undefined>(
		undefined,
	);

	useUpdateEffect(() => {
		const zodErrors = authSignInInputZodSchema.safeParse({ email, password });

		zodErrors.success ? setValidationErrors(undefined) : setValidationErrors(zodErrors);
	}, [email, password]);

	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { signIn } = useSignIn();
	const handleButtonClick = async (_e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		showLoadingScreenCallback();

		await signIn(email, password).finally(() => {
			hideLoadingScreenCallback();
		});
	};

	return (
		<AuthForm
			handlePrimaryButtonClick={handleButtonClick}
			formTitle="サインイン（施設管理者向け）"
			primaryButtonText="サインイン"
			otherInfo={
				<div className="grid justify-end text-right">
					<a href={PATHS.AUTH.SIGN_UP}>
						<Button variant={"link"}>アカウントをお持ちでない場合</Button>
					</a>
					<a href={PATHS.AUTH.FORGOT_PASSWORD}>
						<Button variant={"link"}>パスワードを忘れた場合</Button>
					</a>
				</div>
			}
		>
			<InputTextField
				label="メールアドレス"
				errorMessage={validationErrors?.error.formErrors.fieldErrors.email?.at(0)}
				autoComplete="email"
				name="email"
				type="email"
				placeholder="sample@chillnn.com"
				value={email}
				handleChange={setEmail}
			/>
			<InputPasswordField
				label="パスワード"
				errorMessage={validationErrors?.error.formErrors.fieldErrors.password?.at(0)}
				autoComplete="current-password"
				name="password"
				placeholder="••••••••"
				value={password}
				onChange={setPassword}
			/>
		</AuthForm>
	);
};
